import { createSlice } from '@reduxjs/toolkit';
import apiManagerRoom from 'api/manager-meeting';
import { CALENDAR_VIEW } from 'constants/common';
import moment from 'moment';
import { DEFAULT_TIMESEARCH } from 'constants/search';
import store from 'store/store';
import { convertEventMeeting } from './Func';
import { STATUS_MEETING } from './hook/useManagerMeeting';

export const fetchDataManagerMeeting = async (query) => {
    if (!query) return []
    try {
        let meetingData = []
        let resMeetingComing, resMeetingHistory, resMeetingTrash
        const { type, start, end, page, typeMeeting, roomName, statusDisplay } = query
        // let typeMeetingCustom = '';
        // let statusDisplayCustom = ''

        // if (typeMeeting === '0,1' || typeMeeting === '0,1,2') {
        //     typeMeetingCustom = ''
        // } else if (typeMeeting === '0,2') {
        //     typeMeetingCustom = '0'
        // } else if (typeMeeting === '1,2') {
        //     typeMeetingCustom = '1'
        // } else {
        //     typeMeetingCustom = typeMeeting
        // }

        const statusMeetingIncoming = statusDisplay?.includes(STATUS_MEETING.IN_COMMING) || statusDisplay?.includes(STATUS_MEETING.IN_PROGRESS) || statusDisplay.length === 0;

        const statusMeetingHistory = statusDisplay?.includes(STATUS_MEETING.OUT_OF_DATE) || statusDisplay?.includes(STATUS_MEETING.ENDED) || statusDisplay.length === 0;

        const statusMeetingTrash = statusDisplay?.includes(STATUS_MEETING.CANCEL) || statusDisplay.length === 0;

        if (statusMeetingIncoming) {
            resMeetingComing = await apiManagerRoom.getRoomByType(type, { start, end, page, typeMeeting, roomName })
        }

        if (statusMeetingHistory) {
            let statusDisplayCustom=""
            if(statusDisplay?.includes(STATUS_MEETING.OUT_OF_DATE) && !statusDisplay?.includes(STATUS_MEETING.ENDED)){
                statusDisplayCustom = "1"
            }else if(!statusDisplay?.includes(STATUS_MEETING.OUT_OF_DATE) && statusDisplay?.includes(STATUS_MEETING.ENDED)){
                statusDisplayCustom = "0"
            }
            resMeetingHistory = await apiManagerRoom.getHistory({ start, end, page, typeMeeting, statusDisplay: statusDisplayCustom, roomName })
        }

        if (statusMeetingTrash) {
            resMeetingTrash = await apiManagerRoom.getRoomByType('trash', { start, end, page, typeMeeting, roomName })
        }

        if (statusMeetingIncoming && resMeetingComing?.status === 200) {
            let datas = resMeetingComing?.data?.records;
            if (statusDisplay.length !== 0) {
                if (!statusDisplay?.includes(STATUS_MEETING.IN_COMMING)) {
                    datas = datas.filter(data => data?.type !== "not_start")
                }
                if (!statusDisplay?.includes(STATUS_MEETING.IN_PROGRESS)) {
                    datas = datas.filter(data => data?.type !== "progress")
                }
            }
            meetingData = [...meetingData, ...convertEventMeeting(datas)]
        } else {
            console.log("[Error]: ", resMeetingComing);
        }

        if (statusMeetingHistory && resMeetingHistory?.status === 200) {
            let datas = resMeetingHistory?.data?.listDateStartTotal;
            if (statusDisplay.length !== 0) {
                if (!statusDisplay?.includes(STATUS_MEETING.ENDED)) {
                    datas = datas.filter(data => parseInt(data?.historyStatus) !== 0)
                    datas = datas.filter(data => parseInt(data?.historyStatus) !== 1)    
                }
                if (!statusDisplay?.includes(STATUS_MEETING.OUT_OF_DATE)) {
                    datas = datas.filter(data => data?.historyStatus !== 2)
                }
            }
            meetingData = [...meetingData, ...convertEventMeeting(datas)]
        } else {
            console.log("[Error]: ", resMeetingHistory);
        }

        if (statusMeetingTrash && resMeetingTrash?.status === 200) {
            meetingData = [...meetingData, ...convertEventMeeting(resMeetingTrash?.data?.records)]
        } else {
            console.log("[Error]: ", resMeetingTrash);
        }
        store.dispatch(updateEvents(meetingData))
    } catch (err) {
        console.log("[Error]: ", err);
    }
}

const initialState = {
    events: [],
    query: {
        type: 'not_start-progress',
        start: moment(DEFAULT_TIMESEARCH.startDate).unix() * 1000,
        end: moment(DEFAULT_TIMESEARCH.endDate).unix() * 1000,
        page: 1,
        typeMeeting: '',
        roomName: '',
        statusDisplay: []
    },
    currentDay: Date.now(),
    view: CALENDAR_VIEW.TIME_GRID_WEEK
}

export const managerMeetingSlice = createSlice({
    name: 'managerMeeting',
    initialState,
    reducers: {
        updateEvents: (state, action) => {
            state.events = action.payload
        },
        updateQuery: (state, action) => {
            state.query = action.payload
        },
        resetState: (state) => {
            state.events = []
            state.query = initialState.query
            state.currentDay = Date.now()
            state.view = initialState.view
        },
        updateCurrentDay: {
            reducer: (state, action) => {
                state.currentDay = action.payload
            },
            prepare: (value) => ({
                payload: value?.valueOf ? value.valueOf() : new Date(value).getTime(),
            }),
        },
        updateCalenderView: (state, action) => {
            state.view = action.payload
        }
    }
})
export const { updateEvents, updateQuery, updateCurrentDay, updateCalenderView, resetState } = managerMeetingSlice.actions;
export default managerMeetingSlice.reducer;
